import {
    flattenSlidingLayoutCardProps,
    type UniformSlidingLayoutCard
} from "src/uniform/contenttypes/slidingLayoutCard";

import {
    SlidingLayout,
    type SlidingLayoutCard
} from "@/components/adg4/sliding-layout/src/sliding-layout";

type SlidingLayoutBrightnessMode = "light" | "dark";

type SlidingLayoutColorMode =
    | "none"
    | "backgroundColor"
    | "polygonBackgroundColor"
    | "borderColor"
    | "buttonColor";

export interface UniformSlidingLayoutProps {
    cards: UniformSlidingLayoutCard[];
    brightnessMode?: SlidingLayoutBrightnessMode;
    colorMode?: SlidingLayoutColorMode;
    flattenData?: boolean;
}

const mapCardsToSlidingLayout = (
    cards: UniformSlidingLayoutCard[]
): SlidingLayoutCard[] =>
    cards.map((card) => ({
        title: card.title,
        color: card.color,
        icon: card.icon,
        ctaLinkUrl: card.ctaLinkUrl,
        ctaLinkText: card.ctaLinkText
    }));

const UniformSlidingLayout = (props: UniformSlidingLayoutProps) => {
    const {
        brightnessMode = "light",
        colorMode = "none",
        flattenData = true
    } = props;
    let { cards } = props;

    if (flattenData) {
        cards = flattenSlidingLayoutCardProps(props).cards;
    }

    return (
        <SlidingLayout
            cards={mapCardsToSlidingLayout(cards)}
            brightnessMode={brightnessMode}
            colorMode={colorMode}
        />
    );
};

export default UniformSlidingLayout;
